import { Fragment, useEffect, useState } from 'react';
import { getCyoPromos, updateCustomerCyo, getCustomerCyo } from '../api/api';
import { getPromoData as getPromo } from '@hungryroot/rest/api/get_promo_data/get';
import ProductCard from '../generic/ProductCardSimple';
import styles from './CyoSelector.module.css';

const CyoSelector = ({ onSelection, selected = null, smallImages = false }) => {
  const [promos, setPromos] = useState({});
  const [selectedPromo, selectPromo] = useState(null);

  useEffect(() => {
    getCyoPromos()
      .then((data) => {
        setPromos(data);
      })
      .catch(console.error);
  }, []);

  // select user promo after is fetched:
  useEffect(() => {
    selectPromo(selected);
    if (onSelection) {
      onSelection(selected);
    }
  }, [selected]);

  const selectCyo = (id) => {
    selectPromo(id);
    if (onSelection) {
      onSelection(id);
    }
  };

  return (
    <div className="cyo-selector">
      {promos['cyo_products'] && Array.isArray(promos['cyo_products'])
        ? promos['cyo_products'].map((p) => {
            let selectedClass =
              selectedPromo === promos['cyo_promos'][p.id] ? ' selected' : '';
            return (
              <div
                className={`cyo-product-container${selectedClass}`}
                onClick={() => selectCyo(promos['cyo_promos'][p.id])}
                key={p.id}
              >
                <div className={styles['hr-desktop']}>
                  <ProductCard
                    id={p.id}
                    img={p.small_image_url}
                    brand={p.brand_name}
                    name={p.name}
                    small={smallImages}
                  />
                </div>
                <div className={styles['hr-mobile']}>
                  <div className={`mobile-product-card${selectedClass}`}>
                    <img src={p.large_image_url} alt={p.name} />
                    <div>
                      <div className="hr-subtitle-sm">{p.brand_name}</div>
                      <div className="hr-paragraph-bold">{p.name}</div>
                    </div>
                  </div>
                </div>
                <div className={`checkbox-selector${selectedClass}`}></div>
              </div>
            );
          })
        : null}
    </div>
  );
};

const PostCheckoutCyoSelector = ({
  onUpdateEnd,
  onButtonClick,
  location,
  smallImages,
}) => {
  const [selectedPromo, selectPromo] = useState(null);
  const [customerCyo, setCustomerCyo] = useState(null);
  const [loading, setLoading] = useState(false);
  const onButtonClickAndTracking = (promo) => {
    onButtonClick && onButtonClick();
    dataLayer.push({
      event: `hr.cyo_promo.selected#${location}`,
      promo: promo,
    });
  };

  useEffect(() => {
    getCustomerCyo()
      .then((data) => {
        if (data['cyo_promo']) {
          setCustomerCyo(data['cyo_promo']);
          return getPromo({ promoCode: data['cyo_promo'] });
        }
      })
      .then((data) => {
        if (data) {
          onUpdateEnd && onUpdateEnd(data['free_item_effect']);
        }
      })
      .catch(console.error);
  }, []);

  const updateCyo = () => {
    setLoading(true);
    updateCustomerCyo({ cyo_promo: selectedPromo })
      .then((res) => {
        if (res.updated) {
          setCustomerCyo(selectedPromo);
        }
        return getPromo({ promoCode: selectedPromo });
      })
      .then((data) => {
        onUpdateEnd && onUpdateEnd(data['free_item_effect']);
        onButtonClickAndTracking(selectedPromo);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        onButtonClick && onButtonClick();
        onUpdateEnd && onUpdateEnd();
        console.error(e);
      });
  };

  return (
    <Fragment>
      <div className="hr-mb-32 hr-width-100pct">
        <CyoSelector
          onSelection={(id) => selectPromo(id)}
          selected={customerCyo}
          smallImages={smallImages}
        />
      </div>
      <button
        onClick={updateCyo}
        className="hr-btn-blue"
        disabled={!selectedPromo || selectedPromo === customerCyo || loading}
      >
        UPDATE
      </button>
    </Fragment>
  );
};

export default PostCheckoutCyoSelector;
